import moment from 'moment';
import { DATE_FORMAT } from 'framework/utils';
import type {
  SyberryTodayProject,
  SyberryTodayTaskGroup,
  SyberryTodayTaskStream,
  SyberryTodayWorkItem,
} from 'domain/people/syberryToday/types';

export const EMPTY_TASK_VALUE = 'Empty';

export const getTaskDateLabel = (date: Nullable<string> | undefined) => {
  if (!date) return EMPTY_TASK_VALUE;

  const dueDate = moment.utc(date);

  if (!dueDate.isValid()) return EMPTY_TASK_VALUE;

  return dueDate.format(DATE_FORMAT.DAY);
};

export const getTaskAgeLabel = (date: Nullable<string> | undefined) => {
  if (!date) return EMPTY_TASK_VALUE;

  const addedAtDate = moment(date);

  if (!addedAtDate.isValid()) return EMPTY_TASK_VALUE;

  const daysAgo = Math.max(0, moment().startOf('day').diff(addedAtDate.startOf('day'), 'days'));

  if (!daysAgo) return 'Today';
  if (daysAgo === 1) return '1 day ago';

  return `${daysAgo} days ago`;
};

export const getSelectedGroupProject = (
  projects: SyberryTodayProject[],
  activeGroup: Nullable<SyberryTodayTaskGroup>,
): Nullable<SyberryTodayProject> => {
  if (!activeGroup) return null;

  return projects.find(project => project.id === activeGroup.projectId) ?? null;
};

export const getTasksByStreamId = (tasks: SyberryTodayWorkItem[], stream: SyberryTodayTaskStream) =>
  tasks.filter(task => task.streamId === stream.id);
